import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { SickLeaveListComponent } from './sick-leave-list/sick-leave-list.component';
import { PaperflowListComponent } from './paperflow-list/paperflow-list.component';
import { HrccViewComponent } from './hrcc-view/hrcc-view.component';
import { InvestigationViewComponent } from './investigation-view/investigation-view.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HrccCertificateViewComponent } from './hrcc-certificate-view/hrcc-certificate-view.component';
import { NoEmpidListComponent } from './no-empid-list/no-empid-list.component';
import { NoEmpidComponent } from './no-empid/no-empid.component';

import { AuthGuard } from './guard/auth.guard';

const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'sll', children: [
      {
        path: '',
        component: SickLeaveListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'hrccView/:absenceId/:employeeId',
        component: HrccViewComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'investigationView/:absenceId/:employeeId',
        component: InvestigationViewComponent,
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'pfl',
    children: [
      {
        path: '',
        component: PaperflowListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'hrccCertificateView/:certificateID/:employeeID',
        component: HrccCertificateViewComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: 'nel',
    children: [
      {
        path: '',
        component: NoEmpidListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'noEmpidCertView/:certificateID',
        component: NoEmpidComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  { path: 'pageNotFound', component: PageNotFoundComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: 'sll', pathMatch: 'full' },
  { path: '**', redirectTo: 'sll', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { useHash: true })
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts